import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

import config from "./newRelicConfig";

const newrelic = () => new BrowserAgent(config);

export default newrelic;
